import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-row" }
const _hoisted_2 = { class: "setting-row__text" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "setting-row__description" }


export default {
  __name: 'RecordSettingRow',
  props: {
  title: { type: String, required: true },
  description: { type: String, required: true },
  labelId: { type: String, default: undefined }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: __props.labelId,
        class: "setting-row__title"
      }, _toDisplayString(__props.title), 9, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.description), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

}